export default __webpack_public_path__ + "static/media/wesson.d010e5e2.gif";